<div class="details-column-grid" *ngIf="features.length > 0">
  <div class="details-title-grid">What this includes</div>
  <ul class="details-list-grid">
    <li *ngFor="let feature of features; trackBy: trackByIndex">
      <img src="assets/images/package/circle-check-filled.svg" alt="" aria-hidden="true" />
      {{ feature }}
    </li>
  </ul>
  <button
    type="button"
    class="features-toggle-btn-grid"
    *ngIf="hasHiddenFeatures"
    (click)="toggle.emit()"
  >
    {{ toggleLabel }}
  </button>
</div>
